import { ROLE_TYPE } from '../configs';

export const ROLE_ROUTE_ACCESS = {
  '/': [ROLE_TYPE.ADMIN, ROLE_TYPE.INSPECTOR, ROLE_TYPE.OPERATOR],
  '/vehicles': [ROLE_TYPE.ADMIN],
  '/users': [ROLE_TYPE.ADMIN],
  '/zones': [ROLE_TYPE.ADMIN],
  '/zones/history': [ROLE_TYPE.ADMIN],
  '/rules': [ROLE_TYPE.ADMIN],
  '/policies': [ROLE_TYPE.ADMIN],
  '/telemetry': [ROLE_TYPE.ADMIN],
  '/evacuations': [ROLE_TYPE.ADMIN, ROLE_TYPE.INSPECTOR, ROLE_TYPE.OPERATOR],
  '/statistics': [ROLE_TYPE.ADMIN, ROLE_TYPE.INSPECTOR],
  '/violations': [ROLE_TYPE.ADMIN, ROLE_TYPE.INSPECTOR, ROLE_TYPE.OPERATOR],
  '/provider': [ROLE_TYPE.ADMIN, ROLE_TYPE.INSPECTOR, ROLE_TYPE.OPERATOR],
  '/geography': [ROLE_TYPE.ADMIN],
};

export const isRoleAllowedForPath = (path, role, explicitRoles) => {
  const allowedRoles = explicitRoles || ROLE_ROUTE_ACCESS[path];
  return !allowedRoles || !allowedRoles.length || allowedRoles.includes(role);
};
